import { Drawer, type DrawerProps } from 'antd';

export interface BaseDrawerProps extends DrawerProps {}

/** 抽屉统一宽侧栏外壳、独立滚动与底部操作，调用方可覆盖原生配置。 */
export default function BaseDrawer({
  className,
  rootClassName,
  placement = 'right',
  size,
  closable = { placement: 'end' },
  destroyOnHidden = true,
  ...props
}: BaseDrawerProps) {
  return (
    <Drawer
      {...props}
      placement={placement}
      size={
        size ??
        (placement === 'left' || placement === 'right'
          ? 'var(--base-drawer-size, min(1280px, 82vw))'
          : 378)
      }
      closable={closable}
      destroyOnHidden={destroyOnHidden}
      className={['base-drawer bg-surface-soft', className]
        .filter(Boolean)
        .join(' ')}
      rootClassName={['base-drawer-root', rootClassName]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
